//
//
//
//
//
//
//

import { mapActions } from 'vuex';
import Overview from './_components/Overview';
import Message from './_components/Message';
import Favorites from './_components/Favorites';
import Application from './_components/Application';
import Info from './_components/Info';
// import Basic from './_components/Basic';
import Logout from './_components/Logout';

export default {
  name: 'TrainingManage',
  middleware: 'auth',
  data() {
    return {
      menu: {
        overview: { label: '個人總覽', component: Overview },
        message: {
          label: '訊息通知',
          component: Message,
          hide: !process.env.isMessageOpen,
        },
        favorites: { label: '收藏列表', component: Favorites },
        application: { label: '申請列表', component: Application },
        info: { label: '講師資料', component: Info },
        // basic: { label: '基本設置', component: Basic },
        // logout: { label: '登出', component: Logout },
      },
    };
  },
  head() {
    return {
      title: 'STEP1NE 培訓管理 - 職業培訓課程與資源',
      meta: [
        {
          hid: 'og:title',
          property: 'og:title',
          content: '提升培訓效率 - STEP1NE培訓管理系統',
        },
        {
          hid: 'description',
          name: 'description',
          content:
            'STEP1NE的培訓管理系統提供全面的職業培訓課程與資源管理。專為企業與培訓機構設計，以提高培訓效率和質量。',
        },
        {
          hid: 'og:description',
          property: 'og:description',
          content:
            'STEP1NE的培訓管理系統提供全面的職業培訓課程與資源管理。專為企業與培訓機構設計，以提高培訓效率和質量。',
        },
      ],
    };
  },
  methods: {
    ...mapActions('lecturer', ['getTeachingFields']),
  },
  created() {
    // this.getTeachingFields();
  },
};
